export const API_URL = 'https://forkify-api.jonas.io/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'e9d9db90-8df0-45f0-ba3e-52ac43058661';
export const MODAL_CLOSE_SEC = 2.5;
